import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ISkeleton } from '@app/core/models/skeleton.model';
import { AppFacade } from '@app/facades/app.facade';

@Component({
  selector: 'layout-kyc-verification-error',
  templateUrl: './kyc-verification-error.component.html',
  styleUrls: ['./kyc-verification-error.component.scss'],
})
export class KycVerificationErrorComponent implements OnInit {
  @Input() isLoading: boolean;
  @Output() killPurchaseEvent = new EventEmitter<boolean>();

  public skeletonInfo: ISkeleton[];

  constructor(private _appFacade: AppFacade) {}

  ngOnInit(): void {
    this._appFacade.killPurchaseWithoutRedirect();
    this._setSkeleton();
  }

  public onKillPurchase() {
    this.killPurchaseEvent.emit(true);
  }

  public _setSkeleton() {
    this.skeletonInfo = [
      {
        appearance: 'line',
        theme: {
          height: '30px',
        },
      },
      {
        appearance: 'line',
        theme: {
          height: '100px',
        },
      },
    ];
  }
}
